const BHViewMode = {
	BHViewMode: {
		defaultIconProps: {},
		alternateIconProps: {},
		labelProps: {},
	},
}

export default BHViewMode
